import { formatNumberToShort } from '../../../../helpers'

export const getOptions = legendContainerId => {
  return {
    elements: {
      arc: {
        borderWidth: 0
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: tooltipItem => formatNumberToShort(tooltipItem.raw)
        }
      },
      htmlLegend: {
        // ID of the container to put the legend in
        containerID: legendContainerId
      },
      datalabels: {
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((sum, val) => sum + val, 0)
          const percentage = (value / total) * 100

          if (value > 0 && percentage >= 10) {
            return formatNumberToShort(value)
          } else {
            return ''
          }
        },
        align: 'start',
        anchor: 'end',
        font: {
          size: 15,
          weight: 700
        }
      }
    }
  }
}
